import clsx from 'clsx';
import React from 'react';
import { Box } from '../Box';
import './Badge.css';
import { responsiveCssProperties } from '../../utils';
export function Badge(props) {
    const { children, className, variant = 'neutral', size = 'small', color, ...rest } = props;
    return (React.createElement(Box.Restricted, { elementType: "span", className: clsx('mollie-ui-badge', {
            [`mollie-ui-badge--${variant}`]: variant,
            [`mollie-ui-badge--${size}`]: size,
        }, className), style: responsiveCssProperties({
            '--mollie-ui-badge-color': color,
        }), ...rest }, children));
}
//# sourceMappingURL=Badge.js.map